export const uomList = [
    { text: 'G - GRAMS', value: 'G', description: 'GRAMS' },
    { text: 'MM - MILLIMETERS', value: 'MM', description: 'MILLIMETERS' },
    {
      text: 'MM2 - SQUARE_MILLIMETERS',
      value: 'MM2',
      description: 'SQUARE_MILLIMETERS',
    },
    {
      text: 'MM3 - CUBIC_MILLIMETERS',
      value: 'MM3',
      description: 'CUBIC_MILLIMETERS',
    },
    { text: 'CG - CENTIGRAMS', value: 'CG', description: 'CENTIGRAMS' },
    { text: 'CM - CENTIMETERS', value: 'CM', description: 'CENTIMETERS' },
    {
      text: 'CM2 - SQUARE_CENTIMETERS',
      value: 'CM2',
      description: 'SQUARE_CENTIMETERS',
    },
    {
      text: 'CM3 - CUBIC_CENTIMETERS',
      value: 'CM3',
      description: 'CUBIC_CENTIMETERS',
    },
    { text: 'KG - KILOGRAMS', value: 'KG', description: 'KILOGRAMS' },
    { text: 'M - METER', value: 'M', description: 'METER' },
    { text: 'M2 - SQUARE_METER', value: 'M2', description: 'SQUARE_METER' },
    { text: 'M3 - CUBIC_METER', value: 'M3', description: 'CUBIC_METER' },
    { text: 'MG - MILLIGRAMS', value: 'MG', description: 'MILLIGRAMS' },
    { text: 'MCG - MICROGRAMS', value: 'MCG', description: 'MICROGRAMS' },
  ];

  export const functionCodes = [
    {
      value: 'DIF_CANCEL',
      description: 'Cancellation',
      id: 'DIF_CANCEL',
      key: 'DIF_CANCEL',
    },
    {
      value: 'DIF_CHANGE',
      description: ' Change (Pre-Arrival)',
      id: 'DIF_CHANGE',
      key: 'DIF_CHANGE',
    },
    {
      value: 'DIF_AMEND',
      description: 'Amend (Post-Arrival)',
      id: 'DIF_AMEND',
      key: 'DIF_AMEND',
    },
    {
      value: 'DIF_ORIGINAL',
      description: 'Original',
      id: 'DIF_ORIGINAL',
      key: 'DIF_ORIGINAL',
    },
  ];